import { render, staticRenderFns } from "./Settings_Size.vue?vue&type=template&id=82422fce&scoped=true"
import script from "./Settings_Size.vue?vue&type=script&lang=js"
export * from "./Settings_Size.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82422fce",
  null
  
)

export default component.exports